(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mocha"), require("chai"), require("sinon"), require("sinon-chai"), require("../ringcentral"));
	else if(typeof define === 'function' && define.amd)
		define([, "chai", "sinon", "sinon-chai", "../ringcentral"], factory);
	else if(typeof exports === 'object')
		exports["SDK"] = factory(require("mocha"), require("chai"), require("sinon"), require("sinon-chai"), require("../ringcentral"));
	else
		root["RingCentral"] = root["RingCentral"] || {}, root["RingCentral"]["SDK"] = factory(root[undefined], root["chai"], root["sinon"], root[undefined], root["RingCentral"]["SDK"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/